module.exports = __webpack_public_path__ + "fb04c56f0b1406458a910dd21e855025.png";